import * as PropTypes from 'prop-types';

const basePropTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
  onChange: PropTypes.func.isRequired,
  buttonPlacement: PropTypes.oneOf(['outsideOfInputs', 'inlineWithInputs']),
  className: PropTypes.string,
  doubleClickDelayInMillis: PropTypes.number,
  focusColor: PropTypes.string,
  id: PropTypes.string,
  showTooltipDelayInMillis: PropTypes.number,
  showTooltips: PropTypes.bool,
  size: PropTypes.oneOf(['mini', 'small', 'large', 'big', 'huge', 'massive'])
};

export default basePropTypes;
